/**
 * Project Name: Brainsie eCommerce v4
 * Component: All Categories Section (Dynamic)
 * Description: CMS wrapper for AllCategory component with configurable settings
 * Author: Brainsie Team
 * Date Created: November 1, 2025
 */

import React from "react";
import { Box, Container } from "@mui/material";
import AllCategory from "templates/default/views/Home/Sections/AllCategory";

export default function AllCategoriesSection({ section, darkMode, theme }) {
  // Parse section settings with fallbacks
  const sectionSettings = section.Section_Settings
    ? JSON.parse(section.Section_Settings)
    : {};

  // console.log("🏷️ ALL CATEGORIES SECTION:", {
  //   sectionId: section.Section_Id,
  //   sectionCode: section.Section_Code,
  //   settings: sectionSettings,
  // });

  // Default settings with CMS overrides
  const settings = {
    // Layout settings
    paddingY: sectionSettings.paddingY || 6,
    paddingX: sectionSettings.paddingX || 2,
    maxWidth: sectionSettings.maxWidth || "xl",
    backgroundColor: sectionSettings.backgroundColor || "transparent",

    // Content settings - use section data headings
    showTitle: sectionSettings.showTitle !== false,
    customTitle: section.Section_Heading || sectionSettings.customTitle || "",
    customSubHeading:
      section.Section_Sub_Heading || sectionSettings.customSubHeading || "",
    customSubText:
      section.Section_Sub_Text || sectionSettings.customSubText || "",

    // Grid settings
    gridSpacing: sectionSettings.gridSpacing || 2,
    cardsPerRow: sectionSettings.cardsPerRow || {
      xs: 12,
      sm: 6,
      md: 2,
      lg: 2,
      xl: 2,
    },

    // Visibility settings
    showMore: sectionSettings.showMore !== false,
    initialVisible: sectionSettings.initialVisible || 12,

    // Custom styles
    customStyles: sectionSettings.customStyles || {},
  };

  return (
    <Box
      component="section"
      className="all-categories-section"
      sx={{
        py: settings.paddingY,
        px: settings.paddingX,
        backgroundColor: settings.backgroundColor,
        ...settings.customStyles,
      }}
    >
      <Container maxWidth={settings.maxWidth}>
        <AllCategory
          sectionSettings={settings}
          darkMode={darkMode}
          theme={theme}
        />
      </Container>
    </Box>
  );
}
